// Para formatı — 1.250,00 ₺
export const formatCurrency = (value) => {
  if (value === null || value === undefined || value === '') return '-';
  return Number(value).toLocaleString('tr-TR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }) + ' ₺';
};

// Para formatı — sadece sayı, ₺ yok
export const formatAmount = (value) => {
  if (value === null || value === undefined || value === '') return '-';
  return Number(value).toLocaleString('tr-TR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
};

// Tarih formatı — GG.AA.YYYY
export const formatDate = (value) => {
  if (!value) return '-';
  try {
    const date = new Date(value);
    if (isNaN(date.getTime())) return '-';
    return date.toLocaleDateString('tr-TR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    });
  } catch {
    return '-';
  }
};

// Tarih + Saat formatı
export const formatDateTime = (value) => {
  if (!value) return '-';
  try {
    const date = new Date(value);
    if (isNaN(date.getTime())) return '-';
    return date.toLocaleString('tr-TR');
  } catch {
    return '-';
  }
};

// Yüzde formatı
export const formatPercent = (value, decimals = 1) => {
  if (value === null || value === undefined) return '-';
  return `%${Number(value).toFixed(decimals)}`;
};